/* import __COLOCATED_TEMPLATE__ from './multi-document-event-handler.hbs.js'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();